module.exports = __webpack_public_path__ + "fonts/9d6a331589a0f3bfde472be40540ca0a.txt";